export enum Role {
  student = 'student',
  institution_admin = 'institution_admin',
  admin = 'admin',
  scenario_author = 'scenario_author',
  faculty_member = 'faculty_member',
  account_manager = 'account_manager',
}

export type User = {
  firstName: string
  lastName: string
  email: string
  avatar: string
  role: Role
  roles: Role[]
  institutionId: number
}
